import { BCMSCurrency, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import AccountDetailsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AccountDetailsPage";
import Classes, { Account } from "model";
import { useEffect } from "react";

export default function CaptureAccountsSearchResults(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const showConsumerAccounts = Account.hasConsumerAccounts(branding);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "searchCriteria", "isActive" ], true)
        .update(["searchClearSearchButton", "isActive"], true)
        .submit();

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "submittedSearch", "amount" ], showConsumerAccounts ? BCMSCurrency.init("10") : BCMSCurrency.init("1500"))
        .update([ "submittedSearch", "check" ], showConsumerAccounts ? "2312" : "9553")
        .update([ "search", "amount" ], showConsumerAccounts ? BCMSCurrency.init("10") : BCMSCurrency.init("1500"))
        .update([ "search", "check" ], showConsumerAccounts ? "2312" : "9553")
        .submit(); 
 
    data.transactions = data.search.filter();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AccountDetailsPage ui={ ui } data={ data } />
}